module.exports = __webpack_public_path__ + "6f3ec3613114f2c87eaf44712f1b4897.MP3";